(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/ball-rows/assets/javascripts/ball-rows.js') >= 0) return;  svs.modules.push('/components/tur/ball-rows/assets/javascripts/ball-rows.js');
'use strict';

svs.tur = svs.tur || {};
svs.tur.ball = svs.tur.ball || {};
svs.tur.ball.rows = svs.tur.ball.rows || {};
const Animations = svs.tur.ball.rows.animations.Core,
  HuxFluxAnimations = svs.tur.ball.rows.animations.HuxFlux;
class Rows extends svs.tur.Base {
  constructor(_ref) {
    let {
      rows = [],
      className = 'ball-rows',
      useGrid = false
    } = _ref;
    super({
      rows,
      className
    });
    this.useGrid = useGrid;
    this.rows = rows;
    if (this.useGrid) {
      this.addClass('ball-rows-grid');
    }
  }
  append(rows, visible) {
    const fragment = document.createDocumentFragment();
    rows.forEach(row => {
      fragment.appendChild(row.render(visible));
    });
    this.$el.appendChild(fragment);
  }
  classNames() {
    return ['ball-rows-default'];
  }
  add(rows) {
    let _rows = rows;
    if (!Array.isArray(_rows)) {
      _rows = [rows];
    }
    this.append(_rows);
  }
  render() {
    let visible = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    if (!visible) {
      this.$el.style.opacity = 0;
    }
    this.append(this.rows, visible);
    return this.$el;
  }
  animate() {
    return Animations.in({
      rows: this
    });
  }
  rollIn() {
    return Animations.rollIn({
      rows: this
    });
  }
  slideIn(duration) {
    return Animations.slideIn({
      rows: this,
      duration
    });
  }
  in() {
    return Animations.in({
      rows: this
    });
  }
  huxflux() {
    let random = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    this.huxfluxComplete();
    this._huxfluxTimeline = HuxFluxAnimations.start({
      rows: this,
      random
    });
    return this._huxfluxTimeline;
  }
  huxfluxComplete() {
    if (this._huxfluxTimeline && this._huxfluxTimeline.isActive()) {
      this._huxfluxTimeline.progress(1);
    }
  }
}
svs.tur.ball.rows.Default = Rows;

 })(window);